import { useParams } from 'react-router-dom'
import EditGroupForm from './EditGroupForm'
import { useGetGroupsQuery } from './groupsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetCompaniesQuery } from '../companies/companiesApiSlice'

const EditGroup = () => {
    useTitle('techGroups: Edit Group')

    const { id } = useParams()

    const { username, isManager, isAdmin } = useAuth()

    const { group } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            group: data?.entities[id]
        }),
    })

    const { companies } = useGetCompaniesQuery("companiesList", {
        selectFromResult: ({ data }) => ({
            companies: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!group || !companies?.length) return <PulseLoader color={"#FFF"} />




    const content = <EditGroupForm group={group} companies={companies} />

    return content
}
export default EditGroup